/* REFERENCES
*
* For file upload:
* https://codepen.io/hartzis/pen/VvNGZP?editors=0010
* http://www.hartzis.me/react-image-upload/
*
* For styling input [type="file"] element]
* https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/
* https://coderwall.com/p/uer3ow/total-input-type-file-style-control-with-pure-css
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import ReactSVG from 'react-svg';
import PropTypes from 'prop-types';

import { createMessage } from '~app/actions/app';
import { updateImage } from '~app/actions/nodeList';
import { validateFileSize } from '~app/utils/validation';
import { withT } from "~app/BundleProvider";

class NodeImageUpload extends Component {
  static propTypes = {
    createMessage: PropTypes.func,
    id: PropTypes.string.isRequired,
    imageInfo: PropTypes.object,
    updateImage: PropTypes.func,
  }

  handleImageChange = ({event, t}) => {
    const { createMessage } = this.props;
    event.preventDefault();

    let reader = new FileReader();
    let file = event.target.files[0];

    // if a user cancels the upload, exit this function
    if (!file) return;

    const fileSizeError = validateFileSize(file);
    if (fileSizeError) return createMessage(fileSizeError, "error");

    // make sure file name is lowercased before validating, otherwise JPG, PNG will fail
    const pattern = /\.(jpg|jpeg|png)$/;
    const isValidFileType = pattern.test(file.name.toLowerCase());

    if (!isValidFileType) return createMessage(t("select-jpg"), "error");

    reader.readAsDataURL(file);

    reader.onloadend = () => {
      this.props.updateImage(this.props.id, this.props.index, reader.result, file.name);
    };
  }

  handleImageRemove = () => {
    this.props.updateImage(this.props.id, this.props.index);
  }

  handleImageRef = () => {
    this.refs.imageField.click();
  }

  render() {
    const { imageInfo, t } = this.props;

    const backgroundImage = imageInfo && imageInfo.data ? imageInfo.data : require("~app/resources/images/icons/PhotoIcon.svg");

    const thumbImageStyle = {
      backgroundImage: `url(${backgroundImage})`,
    };

    return (
      <div className="node--image-wrapper">
      {/* The input field is being called using it's ref when you click the image div.
        Tabbing directly into the input element makes the borders not show up, so the tabIndex is in the div instead.
        See: https://stackoverflow.com/questions/34562056/trigger-a-click-on-a-different-element-when-clicking-an-other-div
      */}
      {/* eslint-disable */}
        <div
          aria-label={t("input-image")}
          role="button"
          tabIndex="0"
          className="node--thumbnail-wrapper"
          onClick={this.handleImageRef}
          onKeyPress={(event) => {
            if(event.key === 'Enter' || event.key === ' '){
              this.handleImageRef();
            }
          }}>
          {/* This is a file-upload input disguised as a link
            See: https://coderwall.com/p/uer3ow/total-input-type-file-style-control-with-pure-css
          */}
            <div className="node--image-thumbnail" style={thumbImageStyle} aria-label="Input Image" role="button"></div>
            <input
              className="node--image-input"
              ref="imageField"
              tabIndex="-1"
              type="file"
              name={t("file")}
              onChange={e => this.handleImageChange({event: e, t})}
              value=""
            />
        </div>
        {/* eslint-enable */}
        {imageInfo && imageInfo.data &&
          <div
          role="button"
          onClick={this.handleImageRemove}
          tabIndex="0"
          className="node--image-remove"
          onKeyPress={(event) => {
            if(event.key === 'Enter' || event.key === ' '){
              this.handleImageRemove();
            }
          }}>
            <ReactSVG
              path={require("~app/resources/images/icons/DeleteIconAlt.svg")}
            />
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const node = state.nodeList.present.nodes.find(node => node.id === ownProps.id);
  const imageInfo = node.images[ownProps.index];
  return { imageInfo };
};

const mapDispatchToProps = { createMessage, updateImage };

export default compose(
  withT,
  connect(mapStateToProps, mapDispatchToProps)
)(NodeImageUpload);



// WEBPACK FOOTER //
// ./src/pages/Main/NodeList/NodeImageUpload.js